'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	flattenIdeas = require('@mindmup/mapjs-core/src/content/flatten-ideas'),
	asyncIterator = require('./async-iterator');
module.exports = function AssetUploadController(assetUploaderApi, options) {
	const dispatcher = observable(this),
		askForConfirmation = function (howMany) {
			if (options && options.skipConfirmation) {
				dispatcher.dispatchEvent('uploadInProgress', howMany);
				return Promise.resolve();
			}
			return new Promise((resolve, reject) => {
				dispatcher.cancelUpload = function () {
					dispatcher.dispatchEvent('uploadCancelled');
					reject();
				};
				dispatcher.confirmUpload = function () {
					dispatcher.dispatchEvent('uploadInProgress', howMany);
					resolve();
				};
				dispatcher.dispatchEvent('confirmationRequired');
			});
		},
		askForAuthentication = function () {
			if (options && options.authenticator) {
				return options.authenticator.modalAuthenticate();
			} else {
				return Promise.resolve();
			}
		},
		uploadImagesFromIdeaList = function (ideaArray) {
			const uploadSingleAsset = function (idea, index, total) {
					dispatcher.dispatchEvent('uploadInProgress', (total - index) || 1);
					return assetUploaderApi.uploadAsset(idea);
				},
				proceedWithUpload = function (ideas) {
					return askForAuthentication().then(
						() => {
							return asyncIterator(ideas, uploadSingleAsset)
							.then((result) => {
								if (assetUploaderApi.cleanUp) {
									assetUploaderApi.cleanUp();
								}
								dispatcher.dispatchEvent('uploadComplete');
								return result;
							});
						},
						() => {
							throw 'accessDenied';
						}
					);
				};
			return Promise.resolve().then(() => {
				const ideasWithUploadableAssets = ideaArray.filter(assetUploaderApi.hasUploadableAsset);
				if (ideasWithUploadableAssets && ideasWithUploadableAssets.length) {
					return askForConfirmation(ideasWithUploadableAssets.length)
					.then(() => {
						return proceedWithUpload(ideasWithUploadableAssets);
					}, () => true);
				}
			});
		},
		uploadImagesFromContent = function (content) {
			return uploadImagesFromIdeaList(flattenIdeas(content)).then(() => content);
		},
		addGoldAsset = async (dataUri) => {
			dispatcher.dispatchEvent('uploadInProgress', 1);
			const result = await assetUploaderApi.addGoldAsset(dataUri);
			dispatcher.dispatchEvent('uploadComplete');
			return result;
		},
		optimiseAssets = async () => {
			const onProgress = howMany => dispatcher.dispatchEvent('uploadInProgress', howMany);
			try {
				await assetUploaderApi.uploadAssetsAsChanges(onProgress, () => dispatcher.dispatchEvent('alreadyOptimised'));
				dispatcher.dispatchEvent('uploadComplete');
			} catch (error) {
				dispatcher.dispatchEvent('uploadCancelled');
			}
		};
	Object.assign(this, {uploadImagesFromIdeaList, uploadImagesFromContent, unpack: uploadImagesFromIdeaList, addGoldAsset, optimiseAssets  });
};

